import { DashboardFilters } from "@/dashboard/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardRankingsSpaces } from "../../hooks/use-dashboard-rankings-spaces";
import { RankingsDataTable, type RankingsRow } from "../rankings-data-table";

interface DashboardRankingsSpacesDataTableProps {
  filters: DashboardFilters;
}

export const DashboardRankingsSpacesDataTable = ({
  filters,
}: DashboardRankingsSpacesDataTableProps) => {
  const [t] = useTranslation(["dashboard"]);
  const { isLoading, top3RankingData, otherRankingData } =
    useDashboardRankingsSpaces(filters);

  // O pódio (top 3) deixou de ser cards separados: o Figma mostra o ranking
  // inteiro numa tabela só, na ordem da API.
  const rows = useMemo<RankingsRow[]>(
    () => [...top3RankingData, ...otherRankingData],
    [top3RankingData, otherRankingData],
  );

  return (
    <RankingsDataTable
      data-testid="dashboard-rankings-spaces-table"
      rows={rows}
      isLoading={isLoading}
      nameHeader={t("dashboard-rankings-spaces-table-header-name") as string}
      valueHeader={t("dashboard-rankings-spaces-table-header-value") as string}
    />
  );
};
